import { useCurrentAccount } from '@application/api';
import { CheckoutConfirmationModal, Match } from '@presentation/components';
import type { MtApplicationsBuyerPayModalControllerProps } from './types';

export * from './types';

export const MtApplicationsBuyerPayModalController = (
  props: MtApplicationsBuyerPayModalControllerProps,
) => {
  const { modal, onConfirm, match } = props;
  const { currentAccountCheckoutPriceValue } = useCurrentAccount();

  return (
    <CheckoutConfirmationModal
      modal={modal}
      onConfirm={onConfirm}
      illustration={<Match {...match} />}
      priceValue={currentAccountCheckoutPriceValue} // An AB testing feature
    />
  );
};
